import React, { useState, useEffect } from 'react'

import { Button } from 'Components/shared/Button'
import { AutoComplete } from 'Components/shared/Input'
import { ErrorText } from 'Components/shared/Typography'

import { Flex } from 'lese'

import { useInput, runOnEnter } from 'Helpers'
import UsersService from 'Services/users'
import { toastWithErrorMessage } from 'Helpers/toast'

export default ({ onSelect, buttonText = 'Select User' }) => {
  const [errorText, setErrorText] = useState()
  const [users, setUsers] = useState([])

  const usernameHook = useInput('')
  const [usernameSuggestions, setUsernameSuggestions] = useState([])

  useEffect(async () => {
    const newUsers = await UsersService.list().catch(toastWithErrorMessage('Failed to get users'))
    setUsers(newUsers)
    setUsernameSuggestions(newUsers.map(user => user.username))
  }, [])

  const selectUser = async () => {
    const selectedUser = users.find(user => user.username === usernameHook.value)
    if (!selectedUser) return setErrorText('The user was not found')

    const success = await onSelect(selectedUser)
    if (typeof success === 'string') return setErrorText(success)
    setErrorText()
    usernameHook.reset()
  }

  return (
    <Flex column separation="24px" xAlign="center">
      <AutoComplete
        placeholder="Username"
        suggestions={usernameSuggestions}
        {...usernameHook.bind}
        onKeyDown={runOnEnter(selectUser)}
        tabIndex={0}
      />
      {errorText && <ErrorText>{errorText}</ErrorText>}
      <Button onClick={selectUser} onKeyDown={runOnEnter(selectUser)}>
        {buttonText}
      </Button>
    </Flex>
  )
}
